import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Globals, AuthenData } from '../globals/globals';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
// import { CustomerProfileResponse, ProvinceResponse, CustomerRequest, CustomerResponse } from '../model/criteria/customer';


@Injectable()
export class TruckService {

    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();
    constructor(private http: HttpClient, private global: Globals) { }

    public getCustomerNo(): any {
      return JSON.parse(localStorage.getItem('customerNo'));
  }

   getTruckByCustomer(): Observable<any> {
        return this.http.get<any>(this.global.BaseApiUrl + 'api/Truck/GetTruckByCustomer')
    }

    getTruckOrder(): Observable<any> {
      return this.http.get<any>(this.global.BaseApiUrl + 'api/Truck/GetTruckOrder')
  }

    getTruckByCustomerByID(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Truck/GetTruckByCustomerByID', criteria)
    }

    saveSetting(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Truck/CreateTruck', criteria)
    }

    updateSetting(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Truck/UpdateTruck', criteria)
    }

    findDueDate(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/CustomerDueDate', criteria)
    }

    findBank(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/BankSystem', criteria)
  }

  updateBank(criteria): Observable<any> {
    return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/UpdateSettingBank', criteria)
}

getDriverByCustomer(): Observable<any> {
  return this.http.get<any>(this.global.BaseApiUrl + 'api/Truck/GetDriverByCustomer')
}

getDriverByCustomerByID(criteria): Observable<any> {
  return this.http.post<any>(this.global.BaseApiUrl + 'api/Truck/GetDriverByCustomerByID', criteria)
}

createDriver(criteria): Observable<any> {
  return this.http.post<any>(this.global.BaseApiUrl + 'api/Truck/CreateDriver', criteria)
}

updateDriver(criteria): Observable<any> {
  return this.http.post<any>(this.global.BaseApiUrl + 'api/Truck/UpdateDriver', criteria)
}

getDriverOrder(): Observable<any> {
  return this.http.get<any>(this.global.BaseApiUrl + 'api/Truck/GetDriverOrder')
}

}



// WEBPACK FOOTER //
// ./src/app/services/truck.services.ts